module.exports = __webpack_public_path__ + "static/media/accountHead.9e2ad8ac.svg";